import { render } from "./GroupDetail.vue?vue&type=template&id=c378b334&scoped=true"
import script from "./GroupDetail.vue?vue&type=script&lang=js"
export * from "./GroupDetail.vue?vue&type=script&lang=js"

import "./GroupDetail.vue?vue&type=style&index=0&id=c378b334&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c378b334"]])

export default __exports__